<template>
  <div class="global-service-modules">
    <!-- 1. 走出去高峰论坛 -->
    <div class="module-block module-white">
      <div class="module-container">
        <!-- 右上角更多按钮 -->
        <!-- <div class="more-btn">
            <button @click="goToMore('forum')">More <i class="icon-arrow">→</i></button>
          </div> -->

        <div class="module-content">
          <h3>{{ forumObject.title }}</h3>
          <div v-html="forumObject.desc"></div>
        </div>

        <!-- 多图片展示区 -->
        <div class="module-imgs">
          <img
            v-for="(picUrl, index) in forumObject.picList"
            :key="index"
            :src="picUrl"
            class="module-img-item"
            :alt="`{{forumObject.title}} ${index + 1}`"
          />
        </div>
      </div>
    </div>

    <!--  企业国际化培训 -->
    <div class="module-block module-blue">
      <div class="module-container">
        <!-- <div class="more-btn">
            <button @click="goToMore('training')">More <i class="icon-arrow">→</i></button>
          </div> -->

        <div class="module-content">
          <h3>{{ trainingObject.title }}</h3>
          <div v-html="trainingObject.desc"></div>
        </div>

        <div class="module-imgs">
          <img
            v-for="(picUrl, index) in trainingObject.picList"
            :key="index"
            :src="picUrl"
            class="module-img-item"
            :alt="`{{trainingObject.title}} ${index + 1}`"
          />
        </div>
      </div>
    </div>

    <!-- 展会展览内容-->
    <div class="module-block module-white">
      <div class="module-container">
        <!-- <div class="more-btn">
            <button @click="goToMore('exhibition')">More <i class="icon-arrow">→</i></button>
          </div> -->

        <div class="module-content">
          <h3>{{ exhibitionsObject.title }}</h3>
          <div v-html="exhibitionsObject.desc"></div>
        </div>

        <div class="module-imgs">
          <img
            v-for="(picUrl, index) in exhibitionsObject.picList"
            :key="index"
            :src="picUrl"
            class="module-img-item"
            :alt="`{{exhibitionsObject.title}} ${index + 1}`"
          />
        </div>
      </div>
    </div>

    <!-- 路演活动（白色层） -->
    <div class="module-block module-blue">
      <div class="module-container">
        <!-- <div class="more-btn">
            <button @click="goToMore('roadshow')">More <i class="icon-arrow">→</i></button>
          </div> -->

        <div class="module-content">
          <h3>{{ roadshowObject.title }}</h3>
          <div v-html="roadshowObject.desc"></div>
        </div>

        <div class="module-imgs">
          <img
            v-for="(picUrl, index) in roadshowObject.picList"
            :key="index"
            :src="picUrl"
            class="module-img-item"
            :alt="`{{roadshowObject.title}} ${index + 1}`"
          />
        </div>
      </div>
    </div>

    <!-- 一对一服务 -->
    <div class="module-block module-white">
      <div class="module-container">
        <!-- <div class="more-btn">
            <button @click="goToMore('oneonone')">More <i class="icon-arrow">→</i></button>
          </div> -->

        <div class="module-content">
          <h3>{{ oneOnOneObject.title }}</h3>
          <div v-html="oneOnOneObject.desc"></div>
        </div>

        <div class="module-imgs">
          <img
            v-for="(picUrl, index) in oneOnOneObject.picList"
            :key="index"
            :src="picUrl"
            class="module-img-item"
            :alt="`{{oneOnOneObject.title}} ${index + 1}`"
          />
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "GlobalServiceModules",
  data() {
    return {
      forumObject: {
        title: "International Events",
        desc: `<p>We have established long-term cooperative relations with local governments, foreign embassies and consulates in China, commercial representative offices, investment promotion bureaus and other institutions in more than 130 countries and regions. It receives nearly 400 visits from foreign official institutions every year and provides services for over 7,000 enterprises in their overseas development.</p>
                <p>The platform has organized enterprises to explore overseas markets more than 20 times through exhibitions, economic and trade activities, global roadshows and other formats, sending them to over 10 countries including Germany, the United Kingdom, India, Indonesia, Malaysia, Ethiopia and Russia. It has undertaken nearly 10 economic and trade activities launched by the government in countries such as Germany, the United Kingdom, Russia, South Africa, Ethiopia and Thailand, and organized enterprises to participate in more than 100 training sessions and matchmaking events.</p>`,
        picList: [
          "https://res.roadlinkglb.com/图片/网站/国际活动/深圳2018走出去合作论坛暨科技“一带一路”与“粤港澳大湾区创新”大会.jpg",
          "https://res.roadlinkglb.com/图片/网站/国际活动/2019年第四届深圳走出去合作论坛.jpg",
          "https://res.roadlinkglb.com/图片/网站/国际活动/2020第五届深圳走出去合作论坛.jpg",
        ],
      },
      roadshowObject: {
        title: "International Sci-Tech Innovation Roadshow",
        desc: `<p>Since 2015, the Roadlink GLB platform, in collaboration with Statistical Society for Foreign Economic Relations and Trade of Shenzhen, Shenzhen Outbound Alliance and Shenzhen Industry and Manufacturing Association, has built an international Sci-Tech innovation roadshow platform. It has successively held more than 110 roadshows and recommended over 600 projects. The platform has provided diversified financing channels for enterprises, satisfying the capital needs of enterprises in different industries and at different development stages.</p>
                <p>To help high-quality projects achieve precise docking with the capital market, address the financing needs and overseas expansion challenges of small and medium-sized enterprises, continuously deepen industry-finance cooperation, implement the "integration of technology, industry and finance" special initiative, guide various types of capital to invest early, invest small enterprises and invest hard-core technologies, promote the in-depth integration of technological innovation and industrial innovation, and enhance the inclusiveness and adaptability of the capital market to technological innovation.</p>`,
        picList: [
          "https://res.roadlinkglb.com/图片/网站/科创路演/科创路演第29场.jpg",
          "https://res.roadlinkglb.com/图片/网站/科创路演/科创路演第57场.jpg",
          "https://res.roadlinkglb.com/图片/网站/科创路演/科创路演第58场.jpg",
        ],
      },
      trainingObject: {
        title: "Enterprise Internationalization Training",
        desc: `<p>Since 2015, we have organized enterprises to participate in over 100 training sessions and matching events in total.</p>
                <p>We focus on the core needs of enterprise internationalization training and help enterprises efficiently integrate into the global market. Relying on our profound accumulation of government and enterprise resources, we integrate resources from official institutions, professional service teams and well-known enterprises around the world to provide enterprises with comprehensive international support. The training covers key modules such as policy interpretation, market development, compliance management, risk prevention and cross-cultural communication. Meanwhile, we link supporting services including finance, law and talents to accurately solve various problems faced by enterprises in the process of globalization. From strategic planning to implementation, we provide full-process empowerment to help enterprises avoid risks, integrate resources, steadily expand international business and achieve sustainable development of global layout.</p>`,
        picList: [
          "https://res.roadlinkglb.com/图片/网站/国际化培训/2018粤欧企业对接会.jpg",
          "https://res.roadlinkglb.com/图片/网站/国际化培训/2019中国企业走出去欧洲投资论坛荷兰鹿特丹-通往欧洲之门户.jpg",
          "https://res.roadlinkglb.com/图片/网站/国际化培训/2023中国深圳西班牙马德里经贸合作交流会.jpg",
        ],
      },
      exhibitionsObject: {
        title: "International Exhibitions",
        desc: `<p>Since 2015, we have organized, hosted and provided proxy exhibition services for over 450 events in total.</p>
                <p>With abundant exhibition resources and strong execution capabilities, we provide full-process empowerment for enterprises in exhibition participation, booth setup and on-site sales. We integrate high-quality exhibition resources from multiple countries and regions around the world, covering popular exhibition channels across various industries. Equipped with mature full-process exhibition services, we offer professional services combining standardization and customization—from booth selection, scheme design and booth construction to on-site implementation—ensuring efficient and smooth exhibition participation. Meanwhile, relying on profound industry resources and accurate matchmaking capabilities, we help enterprises connect with high-quality purchasers and potential customers, building an efficient bridge for sales. With professional exhibition organization, comprehensive exhibition support and sales empowerment, we enable enterprises to participate in exhibitions hassle-free, acquire customers efficiently, maximize exhibition value and help them expand market share.</p>`,
        picList: [
          "https://res.roadlinkglb.com/图片/网站/国际展会/2017年印度尼西亚国际消费类电子展.jpg",
          "https://res.roadlinkglb.com/图片/网站/国际展会/2018泰国数字”BIGBANG展览会.jpg",
          "https://res.roadlinkglb.com/图片/网站/国际展会/ICEEIndonesia2018印尼消费类电子展览会盛大开幕.jpg",
        ],
      },
      oneOnOneObject: {
        title: "One-on-one Service",
        desc: `<p>Since 2015, we have provided services for over 70,000 enterprises in their overseas internationalization endeavors.</p>
                <p>The one-on-one internationalization support service for enterprises assigns dedicated consultants to businesses venturing overseas, delivering customized assistance. It covers core areas including overseas market research, policy interpretation, compliance guidance and resource matching, accurately addresses the pain points in enterprise internationalization, reduces expansion risks, and helps them efficiently explore the global market.</p>`,
        picList: [
          "https://res.roadlinkglb.com/图片/网站/一对一服务/澄海玩具协会.jpg",
          "https://res.roadlinkglb.com/图片/网站/一对一服务/盛富金属制品.jpg",
          "https://res.roadlinkglb.com/图片/网站/一对一服务/纺织服装产业协会.jpg",
        ],
      },
    };
  },
  methods: {
    // 更多按钮跳转逻辑（可替换为实际路由/链接）
    goToMore(type) {
      // 示例：根据模块类型跳转不同页面
      const pathMap = {
        forum: "/forum",
        roadshow: "/roadshow",
        training: "/training",
        exhibition: "/exhibitions",
        oneonone: "/oneonone",
      };
      // Vue2 路由跳转（需确保已配置路由）
      this.$router.push(pathMap[type]);

      // 测试用：打印跳转类型
      console.log(`跳转至【${type}】详情页`);
    },
  },
};
</script>
  
  <style scoped>
/* 全局容器 */
.global-service-modules {
  width: 100%;
  background-color: #f8f9fa;
}

/* 标题区样式（匹配原站风格） */
.modules-header {
  background-color: #1a3b69;
  text-align: center;
  padding: 4rem 2rem 2rem;
}
.modules-header .header-line {
  width: 60px;
  height: 3px;
  background-color: #ff9f43; /* 橙色点缀 */
  margin: 0 auto 1rem;
}
.modules-header h2 {
  font-size: 2rem;
  color: #ffffff; /* 深蓝主色 */
  margin: 0;
}
.modules-header p {
  color: #eceef0;
  font-size: 1.1rem;
  margin-top: 0.8rem;
}

/* 模块块：蓝白错层 */
.module-block {
  width: 100%;
  padding: 3rem 0;
  position: relative; /* 为更多按钮定位 */
}
/* 蓝色模块层 */
.module-blue {
  background-color: #2444cb;
  color: #ffffff;
}
/* 白色模块层 */
.module-white {
  background-color: #ffffff;
  color: #333333;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

/* 模块容器：适配PC/移动端 */
.module-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 右上角更多按钮 */
.more-btn {
  position: absolute;
  top: 2rem;
  right: calc((100% - 1200px) / 2 + 2rem); /* 对齐模块容器右侧 */
  z-index: 10;
}
/* 适配移动端：调整更多按钮位置 */
@media (max-width: 1200px) {
  .more-btn {
    right: 2rem;
  }
}
.more-btn button {
  background: transparent;
  border: 1px solid #ff9f43;
  color: #ff9f43;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  transition: all 0.3s ease;
}
/* 白色模块的按钮样式调整 */
.module-white .more-btn button {
  border-color: #1a3b69;
  color: #1a3b69;
}
.more-btn button:hover {
  background-color: #ff9f43;
  color: #ffffff;
  border-color: #ff9f43;
}
.module-white .more-btn button:hover {
  background-color: #1a3b69;
  color: #ffffff;
  border-color: #1a3b69;
}
.icon-arrow {
  font-size: 0.8rem;
}

/* 模块内容区 */
.module-content {
  margin-bottom: 2rem;
}
.module-content h3 {
  font-size: 1.6rem;
  margin: 0 0 1.2rem;
  border-left: 4px solid #ff9f43;
  padding-left: 1rem;
}
.module-content .overview {
  font-size: 1.05rem;
  line-height: 1.7;
  margin: 0 0 1rem;
  font-weight: 500;
}
::v-deep .module-content p {
  text-indent: 2em;
  font-size: 0.95rem;
  line-height: 1.6;
  opacity: 0.9;
}

/* 多图片展示区：自适应排列 */
.module-imgs {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  justify-content: flex-start;
}
.module-img-item {
  width: calc(33.33% - 1rem);
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}
.module-img-item:hover {
  transform: translateY(-5px);
}
/* 移动端图片适配 */
@media (max-width: 768px) {
  .module-img-item {
    width: calc(50% - 0.75rem);
    height: 150px;
  }
  .module-content h3 {
    padding-right: 200px;
    box-sizing: border-box;
  }
}
@media (max-width: 480px) {
  .module-img-item {
    width: 100%;
    height: 180px;
  }

  .module-content h3 {
    padding-right: 150px;
    box-sizing: border-box;
  }
}
</style>